export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "chat.worker.f848c26b196c8175f1da.worker.js");
}
